@for (doc of documents; track $index) {
  <div class="uk-card uk-card-default uk-margin-bottom" [attr.id]="'card-' + doc.result.id">
    <div class="uk-card-body">
      @if (alertStates[doc.result.id]) {
        <div class="uk-margin-small-bottom uk-animation-fade">
          <div [ngClass]="{'uk-alert uk-alert-success uk-text-center': alertStates[doc.result.id].type === 'success', 'uk-alert uk-alert-danger uk-text-center': alertStates[doc.result.id].type === 'danger'}"
               data-uk-alert>
            <a class="uk-alert-close" data-uk-close></a>
            <p>{{ alertStates[doc.result.id].message }}</p>
          </div>
        </div>
      }
      @if (isAdminPage) {
        <div class="uk-flex uk-flex-right uk-margin-bottom">
          <div [ngClass]="{'uk-label-success': doc.result.status === 'APPROVED','uk-label-danger': doc.result.status === 'REJECTED','uk-label-warning': doc.result.status === 'PENDING'}">
            {{ doc.result.status }}
          </div>
        </div>
      }
      @if (!doc.result.docInfo) {
        <div>
          No information was found or generated for this URL
          <a href="{{doc.result.url}}" target="_blank">{{ doc.result.url }}</a>
        </div>
      } @else {
        <div class="uk-card-title">
          <div class="uk-flex uk-flex-middle uk-flex-between uk-margin-small-bottom">
            <div class="uk-flex uk-flex-middle">
              @if (!(showImage.get(doc.result.id) === false)) {
                <img ngSrc="../../survey-tool/assets/images/flags/{{$safeNavigationMigration(doc.result.docInfo?.country) | lowercase}}-flag-round.png"
                     class="flag-image uk-margin-small-right" width="30" height="20"
                     alt="{{doc.result.docInfo?.country}} flag" (error)="imageError(doc.result.id)">
              }
              <strong>
                <a [routerLink]="['../document-landing', doc.result.id]">
                  @if ((getHighlightForField(doc, 'title') ?? doc.result.docInfo?.title)) {
                    <span [innerHTML]="getHighlightForField(doc, 'title') ?? doc.result.docInfo?.title"></span>
                  } @else if (isAdminPage) {
                    <span class="uk-text-muted">&#123; No title found &#125;</span>
                  }
                </a>
              </strong>
              <span style="margin-left: 20px;"></span>
              @if (doc.result.url) {
                <a [href]="doc.result.url" target="_blank">
                  <span class="material-symbols-outlined" style="font-size: 20px; vertical-align: middle;">open_in_new</span>
                </a>
              }
            </div>
            <div class="uk-flex uk-flex-middle">
              @for (tag of doc.result.docInfo?.tags; track $index) {
                <span class="uk-label uk-margin-small-left uk-label-primary uk-text-bold">{{ tag }}</span>
              }
            </div>
          </div>
        </div>
        @if (doc.result.docInfo?.publicationDate || doc.result.docInfo?.startDate || doc.result.docInfo?.endDate) {
          <div
            class="uk-text-small uk-margin-small-bottom document-dates-metadata">
            @if (doc.result.docInfo?.publicationDate) {
              <span>
                Publication Date: {{ doc.result.docInfo.publicationDate |date:'mediumDate' }}
              </span>
            }
            @if (doc.result.docInfo?.startDate) {
              <span>Start Date: {{ doc.result.docInfo.startDate | date:'mediumDate' }}</span>
            }
            @if (doc.result.docInfo?.endDate) {
              <span>End Date: {{ doc.result.docInfo.endDate | date:'mediumDate' }}</span>
            }
          </div>
        }
        @if (doc.result.docInfo?.authors && doc.result.docInfo?.authors?.length > 0) {
          <div class="uk-text-small uk-margin-small-bottom">
            <div class="uk-margin-xsmall-bottom">
              <div class="uk-height-max-medium uk-overflow-auto uk-text-small uk-text-emphasis uk-flex uk-flex-wrap">
                <span class="uk-text-meta uk-margin-xsmall-right"> Authors: </span>
                @for (author of doc.result.docInfo.authors; track $index) {
                  <span class="uk-text-italic" style="margin-right: 5px;"> {{ author.name }}</span>
                }
              </div>
            </div>
          </div>
        }
        @if (doc.result.docInfo?.shortDescription) {
          <p [title]="doc.result.docInfo?.shortDescription?.generated ? 'This description is AI-generated' : null">
            @if (doc.result.docInfo?.shortDescription?.generated) {
              <span class="material-symbols-outlined" style="font-size: 16px">star_shine</span>
            }
            <span [innerHTML]="getHighlightForField(doc, 'shortDescription') ?? doc.result.docInfo?.shortDescription?.text"></span>
          </p>
        }
        @if (doc.result.docInfo?.organisations && doc.result.docInfo?.organisations?.length > 0) {
          <div class="uk-text-small uk-margin-small-bottom">
            <div class="uk-margin-xsmall-bottom">
              <div class="uk-height-max-medium uk-overflow-auto uk-text-small uk-text-emphasis uk-flex uk-flex-wrap">
                <span class="uk-text-meta uk-margin-xsmall-right"> Organisations: </span>
                @for (organisation of doc.result.docInfo.organisations; track $index; let i = $index) {
                  @if (i !== 0) {
                    <span class="uk-margin-xsmall-right">,</span>
                  }
                  <span [innerHTML]="organisation"></span>
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
    @if (isAdminPage) {
      <div class="uk-card-footer">
        <div class="uk-flex uk-flex-right">
          <a [routerLink]="['../document-edit', doc.result.id]" title="Edit Document"
             class="uk-link uk-link-reset uk-margin-medium-right uk-flex uk-flex-middle uk-text-small">
            <span class="material-symbols-outlined uk-margin-xsmall-right" style="font-size: 18px">edit</span>Edit
          </a>
          <!--                <hr class="uk-divider-vertical">-->
          <a (click)="updateStatus(doc.result.id, 'APPROVED')" class="uk-link uk-link-reset uk-flex uk-flex-middle uk-text-small"
             style="padding-left: 40px; border-left: 1px solid #ccc; cursor: pointer;">
            <span class="material-symbols-outlined uk-margin-xsmall-right" style="font-size: 18px">check_circle</span>Approve
          </a>
          <a (click)="updateStatus(doc.result.id, 'REJECTED')" class="uk-link uk-link-reset uk-flex uk-flex-middle uk-text-small"
             style="padding-left: 40px; border-left: 1px solid #ccc; margin-left: 10px; cursor: pointer;">
            <span class="material-symbols-outlined uk-margin-xsmall-right" style="font-size: 18px">cancel</span>Reject
          </a>
        </div>
      </div>
    }
  </div>
}
